module.exports = __webpack_public_path__ + "img/cartao_master.c406cdc9.svg";